export default __webpack_public_path__ + "static/media/YCombinator.5be7366c.svg";